module.exports = __webpack_public_path__ + "7e4b29ba/img/comments-icon.fdec7fdb.svg";